<template>
  <el-dialog
    :title="$t('productSeckill.editSeckill')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <el-form
      ref="editForm"
      :model="editProductSeckillInfo"
      label-width="120px"
      label-position="right"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            :label="$t('productSeckill.seckillDesc')"
            prop="prodDesc"
          >
            <el-input
              v-model="editProductSeckillInfo.prodDesc"
              type="textarea"
              :placeholder="$t('productSeckill.seckillDescPlaceholder')"
            />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$t('productSeckill.killHours')"
            prop="killHours"
          >
            <el-select
              v-model="editProductSeckillInfo.killHours"
              :placeholder="$t('productSeckill.killHoursPlaceholder')"
              style="width:100%"
            >
              <el-option
                v-for="hours in editProductSeckillInfo.selectsHours"
                :key="hours"
                :label="`${hours}点`"
                :value="hours"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$t('productSeckill.continueHours')"
            prop="continueHours"
          >
            <el-input
              v-model="editProductSeckillInfo.continueHours"
              :placeholder="$t('productSeckill.continueHoursPlaceholder')"
            />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$t('productSeckill.validPurchase')"
            prop="totalCount"
          >
            <el-input
              v-model="editProductSeckillInfo.totalCount"
              type="number"
              :placeholder="$t('productSeckill.validPurchasePlaceholder')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$t('productSeckill.onePurchaseCount')"
            prop="oneCount"
          >
            <el-input
              v-model="editProductSeckillInfo.oneCount"
              type="number"
              :placeholder="$t('productSeckill.onePurchaseCountPlaceholder')"
            />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$t('productSeckill.killPrice')"
            prop="killPrice"
          >
            <el-input
              v-model="editProductSeckillInfo.killPrice"
              :placeholder="$t('productSeckill.killPricePlaceholder')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$t('productSeckill.limit')"
            prop="killStock"
          >
            <el-input
              v-model="editProductSeckillInfo.killStock"
              :placeholder="$t('productSeckill.limitPlaceholder')"
            />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$t('productSeckill.startTime')"
            prop="startTime"
          >
            <el-date-picker
              v-model="editProductSeckillInfo.startTime"
              type="datetime"
              :placeholder="$t('productSeckill.startTimePlaceholder')"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width:100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$t('productSeckill.endTime')"
            prop="endTime"
          >
            <el-date-picker
              v-model="editProductSeckillInfo.endTime"
              type="datetime"
              :placeholder="$t('productSeckill.endTimePlaceholder')"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width:100%"
            />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$t('productSeckill.status')"
            prop="state"
          >
            <el-select
              v-model="editProductSeckillInfo.state"
              :placeholder="$t('productSeckill.statusPlaceholder')"
              style="width:100%"
            >
              <el-option
                :label="$t('productSeckill.open')"
                value="1001"
              />
              <el-option
                :label="$t('productSeckill.close')"
                value="2002"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button
        type="primary"
        @click="editProductSeckill"
      >
        {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateProductSeckill } from '@/api/group/productSeckillApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditProductSeckill',
  data() {
    return {
      dialogVisible: false,
      editProductSeckillInfo: {
        killId: '',
        productId: '',
        valueId: '',
        prodName: '',
        prodDesc: '',
        killHours: '',
        continueHours: '',
        totalCount: '',
        oneCount: '',
        killPrice: '',
        killStock: '',
        state: '',
        startTime: '',
        endTime: '',
        selectsHours: [8, 10, 12, 14, 15, 16, 20, 22]
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.$nextTick(() => {
        Object.assign(this.editProductSeckillInfo, row)
      })
    },
    handleClose() {
      this.$refs.editForm.resetFields()
      this.editProductSeckillInfo = {
        killId: '',
        productId: '',
        valueId: '',
        prodName: '',
        prodDesc: '',
        killHours: '',
        continueHours: '',
        totalCount: '',
        oneCount: '',
        killPrice: '',
        killStock: '',
        state: '',
        startTime: '',
        endTime: '',
        selectsHours: [8, 10, 12, 14, 15, 16, 20, 22]
      }
    },
    async editProductSeckill() {
      try {
        this.editProductSeckillInfo.shopId = getShopId()
        await this.$refs.editForm.validate()
        await updateProductSeckill(this.editProductSeckillInfo)
        this.$message.success(this.$t('common.saveSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        this.$message.error(error)
        console.error(error)
      }
    }
  }
}
</script>